"use client";

import React from 'react';
import Link from 'next/link';
import {
  BeakerIcon,
  ShoppingBagIcon,
  BanknotesIcon,
  TruckIcon,
  CogIcon,
  HeartIcon,
  FireIcon,
  BoltIcon,
  SignalIcon,
  CubeIcon,
  GlobeAltIcon,
  ShieldCheckIcon,
  TruckIcon as TransportIcon,
  AcademicCapIcon,
  ChartBarIcon,
  CpuChipIcon
} from '@heroicons/react/24/outline';

const IndustriesSection = () => {
  const industries = [
    { name: "Pharmaceutical", icon: BeakerIcon },
    { name: "Retail", icon: ShoppingBagIcon },
    { name: "Finance", icon: BanknotesIcon },
    { name: "Logistics", icon: TruckIcon },
    { name: "Manufacturing", icon: CogIcon },
    { name: "Healthcare", icon: HeartIcon },
    { name: "Oil & Gas", icon: FireIcon },
    { name: "Energy & Utilities", icon: BoltIcon },
    { name: "Telecommunications", icon: SignalIcon },
    { name: "CPG / FMCG", icon: CubeIcon },
    { name: "Hospitality & Travel", icon: GlobeAltIcon },
    { name: "Insurance", icon: ShieldCheckIcon },
    { name: "Transportation", icon: TransportIcon },
    { name: "Education", icon: AcademicCapIcon },
    { name: "Market Research", icon: ChartBarIcon },
    { name: "Technology", icon: CpuChipIcon }
  ];

  return (
    <section className="bg-navy py-12 sm:py-16 md:py-24 min-h-0 flex items-center">
      <div className="container mx-auto px-4 sm:px-6 max-w-7xl">
        {/* Headline */}
        <h2 className="font-serif text-white text-[28px] sm:text-[36px] md:text-[42px] lg:text-[44px] leading-[1.3] font-bold text-left md:text-center mb-4 sm:mb-6">
          Industries We Serve
        </h2>

        {/* Subheadline */}
        <p className="text-white/60 text-[15px] sm:text-base md:text-lg leading-[1.7] text-left md:text-center max-w-3xl md:mx-auto mb-10 sm:mb-16">
          Enterprise data solutions tailored for your industry
        </p>

        {/* Industries Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 gap-3 sm:gap-4 mb-10 sm:mb-16">
          {industries?.map((industry, index) => {
            const IconComponent = industry?.icon;
            return (
              <div
                key={index}
                className="bg-white/[0.03] border border-white/[0.08] rounded-lg p-4 sm:p-5 md:p-6 hover:border-gold/40 hover:bg-white/[0.05] transition-all duration-300 group cursor-pointer touch-manipulation"
              >
                <div className="flex items-center justify-start md:justify-center mb-2 sm:mb-3">
                  <IconComponent className="w-6 h-6 sm:w-7 sm:h-7 md:w-8 md:h-8 text-gold/80 group-hover:text-gold group-hover:scale-110 transition-all duration-300" />
                </div>
                <h3 className="text-white text-[12px] sm:text-[13px] md:text-sm font-medium text-left md:text-center leading-tight">
                  {industry?.name}
                </h3>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="flex justify-start md:justify-center">
          <Link
            href="/industries"
            className="inline-block text-center w-full sm:w-auto min-h-[48px] bg-gold text-navy px-6 sm:px-8 py-4 rounded-lg font-semibold text-[14px] sm:text-base hover:bg-gold/90 transition-all active:scale-[0.98]"
          >
            Explore Industry Solutions →
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;